import { useCallback } from 'react';

import usePostMessageListener from './use-post-message-listener';
import { updateMessages, setType } from '../modules/messages';
import { useDispatch } from 'react-redux';
import { setConfig, setVisibilityConfig } from '../modules/config';
import { setTint, updateTintPersonalization } from '../modules/tint';
import { clearPost, setPosts, updateTaggedProducts } from '../modules/posts';
import { globalConfig } from '../../../shared/config/config';

export default (): void => {
  const dispatch = useDispatch();

  const memoizedUsePostMessageListenerCallback = useCallback(
    data => {
      switch (data.type) {
        case globalConfig.postMessage.actions.openPopup:
          dispatch(setConfig(data.config));
          dispatch(
            setTint({
              personalization: data.personalization,
              socialFeeds: data.socialFeeds,
              meta: data.meta,
              customFontPopup: data.customFontPopup,
            })
          );
          dispatch(setType(data.type));
          dispatch(
            setPosts({
              // For table theme we would like to display image only posts in the popup
              posts:
                data.personalization.attributes.theme !== globalConfig.themes.table
                  ? data.posts
                  : data.posts.filter(post => post.attributes.image_url || post.attributes.video_url),
              index: data.index,
              taggedProducts: data.taggedProducts,
              products: data.products,
            })
          );
          dispatch(updateMessages({ key: 'isMounted', value: true }));
          break;

        case globalConfig.postMessage.actions.hidePopup:
          dispatch(setVisibilityConfig(data.hidePopup));
          break;

        case globalConfig.postMessage.actions.openPublicPost:
        case globalConfig.postMessage.actions.openReview:
          dispatch(setConfig(data.config));
          dispatch(setTint({ personalization: data.personalization, socialFeeds: data.socialFeeds, meta: data.meta }));
          dispatch(setType(data.type));
          dispatch(updateMessages({ key: 'isMounted', value: true }));
          break;

        case globalConfig.postMessage.actions.editorPersonalizationChanged:
          dispatch(updateTintPersonalization(data.personalization));
          break;

        case globalConfig.postMessage.actions.editorClosedPopup:
          dispatch(clearPost());
          dispatch(updateMessages({ key: 'isCloseClickedFromDashboard', value: true }));
          break;

        case globalConfig.postMessage.actions.updatePopupData:
          dispatch(updateTaggedProducts({ taggedProducts: data.taggedProducts, products: data.products }));
          break;
        case globalConfig.postMessage.actions.tintAnalyticsScriptLoaded:
          dispatch(updateMessages({ key: 'isAnalyticsLoaded', value: true }));
          break;

        default:
          break;
      }
    },
    [dispatch]
  );

  usePostMessageListener(memoizedUsePostMessageListenerCallback);
};
